import template from './RequestAccessModalView.hbs';

import './RequestAccessModalView.less';

import {PermissionRequestModel} from '../../../shared/model/users/PermissionRequestModel';
import {BaseModal2} from '../../../shared/view/BaseModal2/BaseModal2';
import {UserModel} from '../../../shared/model/users/UserModel';
import {ValidityModel} from '../../../shared/model/base/ValidityModel';

/**
 * @class RequestAccessModalView
 * @extends BaseModal
 *
 
 */
export class RequestAccessModalView extends BaseModal2 {

    get template () {

        return template;
    }

    get className () {

        return 'df-ui-overlay request-access';
    }

    initialize (options) {

        super.initialize(options);

        this.emailModel = new Backbone.Model({requesteeEmail : ''});
        this.permissionRequestModel = new PermissionRequestModel();
        this.validityModel = new ValidityModel({isValid: false});
        this.listenTo(this.emailModel, 'change:requesteeEmail', this.onUserEmailChange);
    }

    onEmailIsUserEmail () {

        Radio.channel('NOTIFICATION').trigger('NOTIFY', {
            content: __('INVITE_COLLABORATORS_LAYOUT.REQUEST_ACCESS_MODAL_VIEW.ERROR_EMAIL_IS_USER_MAIL')
        });
    }

    onUserEmailChange() {

        let isEmailIsValid = !UserModel.validateEmail(this.emailModel.attributes.requesteeEmail);

        this.validityModel.set('isValid', isEmailIsValid);
    }

    onRequestAccess() {

        if (this.emailModel.get('requesteeEmail') === this.options.hash.requesterEmail) {

            return this.onEmailIsUserEmail();
        }

        this.fetchProfile =  $.ajax({
            url: (API_PREFIX + '/users/users?email=["' + this.emailModel.get('requesteeEmail').toLowerCase() + '"]'),
            type: 'GET',
            dataType: 'json',
            contentType: 'application/json'
        }).done((response) => {

            if(response[0] && this.options.hash.requesterCountry !== response[0].country) {
                Radio.channel('NOTIFICATION').trigger('NOTIFY', {
                    content: __('INVITE_COLLABORATORS_LAYOUT.COLLABORATORS_ITEM_VIEW.INVALID_COUNTRY')
                });
            }
            else {
                if (response[0] && response[0].uuid) {
                    this.permissionRequestModel.save({'requesteeId': response[0].uuid})
                        .done(() => {
                            Radio.channel('NOTIFICATION').trigger('NOTIFY', {
                                content: __('INVITE_COLLABORATORS.REQUEST_SUCCESS'),
                                isSuccess: true
                            });
                            this.options.hash.saveSuccess();
                        });
                } else {
                    Radio.channel('NOTIFICATION').trigger('NOTIFY', {
                        content: __('REQUEST_ACCESS_MODAL.NO_USER_MESSAGE')
                    });
                }
            }
        });
    }

    serializeData () {

        return _.extend({}, this.options.hash, {
            context: this,
            onRequestAccess: this.onRequestAccess,
            permissionRequestModel: this.permissionRequestModel,
            emailModel: this.emailModel,
            invitationModel: this.invitationModel,
            validityModel: this.validityModel,
            isNotValid: !this.validityModel.get('isValid')
        });
    }

}


// WEBPACK FOOTER //
// ./layout/InviteCollaboratorsLayout/RequestAccessModalView/RequestAccessModalView.js